module.exports = __webpack_public_path__ + "images/bluekens_small8ac2e9a01aeaee3bd7ab77278980a0a9.png";